import { Col, Form, Row } from "antd";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { SelectRota } from "components/select/SelectRota";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";

export function FilterBar() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter(formValues);
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={true} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
